import { ApiClient } from '@/config/axios.config';

export interface CargoListDataItem {
  Id: number;
  Name: string;
}

export type CargoListDataType =
  | 'TradeName'
  | 'CompanyNameBroker'
  | 'CompanyNameCharterer'
  | 'CompanyNameRateAssessor'
  | 'PrivacyLevelsName'
  | 'FixtureTypeName'
  | 'FixtureStatusNameCargo'
  | 'DataCertaintyCategoriesName';

class CargoListDataService {
  private baseUrl = '/cargolist/data';

  /**
   * Fetch data by list type from the new cargo list API
   */
  async getListData(listType: CargoListDataType): Promise<CargoListDataItem[]> {
    try {
      return await ApiClient.get<CargoListDataItem[]>(`${this.baseUrl}?list=${listType}`);
    } catch (error) {
      console.error(`Error fetching ${listType} data:`, error);
      throw new Error(`Failed to fetch ${listType} data`);
    }
  }

  // Convenience methods for specific data types
  async getTrades(): Promise<CargoListDataItem[]> {
    return this.getListData('TradeName');
  }

  async getBrokers(): Promise<CargoListDataItem[]> {
    return this.getListData('CompanyNameBroker');
  }

  async getCharterers(): Promise<CargoListDataItem[]> {
    return this.getListData('CompanyNameCharterer');
  }

  async getRateAssessors(): Promise<CargoListDataItem[]> {
    return this.getListData('CompanyNameRateAssessor');
  }

  async getPrivacyLevels(): Promise<CargoListDataItem[]> {
    return this.getListData('PrivacyLevelsName');
  }

  async getFixtureTypes(): Promise<CargoListDataItem[]> {
    return this.getListData('FixtureTypeName');
  }

  async getFixtureStatuses(): Promise<CargoListDataItem[]> {
    return this.getListData('FixtureStatusNameCargo');
  }

  async getDataCertaintyCategories(): Promise<CargoListDataItem[]> {
    return this.getListData('DataCertaintyCategoriesName');
  }
}

export const cargoListDataService = new CargoListDataService();
